// src/utils/StorageFactory.js
class StorageFactory {
  constructor(storageType = 'session') {
    this.storage = storageType === 'local' ? localStorage : sessionStorage;
  }

  add(key, value) {
    try {
      const val = typeof value === 'string' ? value : JSON.stringify(value);
      this.storage.setItem(key, val);
    } catch (e) {
      console.error(
        `Error adding item to ${
          this.storage === localStorage ? 'local' : 'session'
        }Storage`,
        e
      );
    }
  }

  get(key) {
    const value = this.storage.getItem(key);
    if (value === null) return null;
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  remove(key) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }

  has(key) {
    return this.storage.getItem(key) !== null;
  }

  getAll() {
    const allItems = {};
    for (let i = 0; i < this.storage.length; i++) {
      const key = this.storage.key(i);
      if (key) {
        allItems[key] = this.get(key);
      }
    }
    return allItems;
  }
}

export default StorageFactory;
